import React from 'react';

import { useSelector } from 'react-redux';

import { SvgImage } from '../../../../../../shared/components';
import { i18n } from '../../../../../../shared/helpers/i18n';
import { Role } from '../../../../../../shared/helpers/permissions';
import { getSelfRole } from '../../../permissions';
import { selectIsCloudRecordingAvailable, selectIsCloudRecordingRunning } from '../../selectors';
import styles from './styles.css';

export function CloudRecordingTile() {
    const isCloudRecordingAvailable = useSelector(selectIsCloudRecordingAvailable);
    const isCloudRecordingRunning = useSelector(selectIsCloudRecordingRunning);
    const isOwner = useSelector(getSelfRole) === Role.OWNER;

    if (!isCloudRecordingAvailable || !isCloudRecordingRunning) {
        return null;
    }

    const message = i18n('participants-sidebar', 'cloud-recording-in-progress');
    const tip = isOwner
        ? i18n('participants-sidebar', 'cloud-recording-owner-tip-v2')
        : i18n('participants-sidebar', 'cloud-recording-member-tip-v2');

    return (
        <div className={styles.cloudRecordingTile}>
            <div className={styles.cloudRecordingTileContent}>
                <SvgImage imageName="pulseRecordingDot" className={styles.cloudRecordingTileIcon}></SvgImage>
                <div className={styles.cloudRecordingTileDescription}>
                    <span className={styles.cloudRecordingTileMessage}>{message}</span>
                    <span className={styles.cloudRecordingTileTip}>{tip}</span>
                </div>
            </div>
        </div>
    );
}
